import { cleanObject, getDecodedValue, getWindowRef, queryStringToObject } from "@hiptraveler/common";

export interface CheckInDateRange<T = string> {
  checkInDate?: T;
  checkOutDate?: T;
}

export function getCheckInDateRange(): CheckInDateRange {

  const query = queryStringToObject(getWindowRef()?.location?.search || '?') as any;

  return cleanObject({ // Format: MM-DD-YYYY
    checkInDate: getDecodedValue(query?.checkInDate),
    checkOutDate: getDecodedValue(query?.checkOutDate)
  });
}

